import { useState, useMemo, useEffect } from "react";

const usePagination = <T>(data: T[] = [], pageSize: number) => {
  const [page, setPage] = useState(0);
  const lastPage = Math.ceil(data.length / pageSize);

  const skipToPage = (newPage: number) => {
    setPage(newPage);
  };
  // Below effect added to pair with search/other filters everytime dataset changes (is filtered at a higher level)
  useEffect(() => {
    skipToPage(0);
  }, [data]);

  const pageData = useMemo(() => {
    const start = page * pageSize;
    const end = start + pageSize;
    return data.slice(start, end);
  }, [page, data, pageSize]);

  const next = () => {
    setPage(page + 1);
  };

  const previous = () => {
    setPage(page - 1);
  };

  const skipToFirstPage = () => {
    setPage(1);
  };

  const skipToLastPage = () => {
    setPage(lastPage);
  };

  return {
    page,
    pageData,
    lastPage,
    next,
    previous,
    skipToFirstPage,
    skipToLastPage,
    skipToPage,
    setPage,
  };
};

export default usePagination;
